import React from 'react';
import AnchorLink from '@app/components/ui/links/anchor-link';
import ArrowTopRight from '@app/components/icons/arrow-top-right';
import { VacancyDto } from '@app/models/dtos/strapi';

function VacancyRow({ vacancy }: { vacancy: VacancyDto }) {
    return (
        <>
            <div className="hover:bg-blue-5/10 group flex w-full flex-col gap-10 border-t border-b-borderColor border-t-borderColor py-10 transition-colors sm:flex-row sm:items-center md:gap-[120px] md:px-4">
                <p className="h5 text-balck-1 w-full">{vacancy.position}</p>
                <div className="P2 w-full text-black-1">
                    <p>{vacancy.location}</p>
                    <p>{vacancy.employmentType}</p>
                </div>
                <AnchorLink href={`/career/${vacancy.slug}`} className="inline-flex w-fit items-center gap-2 rounded-[1000px] bg-blue px-[16px] py-[6px] no-underline sm:ml-auto">
                    <p className="P1 whitespace-nowrap !text-white">View Role</p>
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-6">
                        <ArrowTopRight className="h-3 w-3 text-white" />
                    </span>
                </AnchorLink>
            </div>
        </>
    );
}

export default VacancyRow;
